import { render, staticRenderFns } from "./personal-center-setMeal.vue?vue&type=template&id=bf7de794&scoped=true&"
import script from "./personal-center-setMeal.vue?vue&type=script&lang=js&"
export * from "./personal-center-setMeal.vue?vue&type=script&lang=js&"
import style0 from "./personal-center-setMeal.vue?vue&type=style&index=0&id=bf7de794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7de794",
  null
  
)

export default component.exports